"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.game_manager = exports.KHGameManager = exports.set_scale = exports.game = exports.game_bounds = exports.card_size = void 0;
const KHInputScene_1 = require("./KH/Input/KHInputScene");
const CTGMainMenuScene_1 = require("./MenuScenes/CTGMainMenuScene");
const CTGPreloadScene_1 = require("./CTGPreloadScene");
const CTGOptions_1 = require("./CTGOptions");
const CTGGameScene_1 = require("./CTGGameScene");
const CTGCreditsScene_1 = require("./MenuScenes/CTGCreditsScene");
const CTGOptionsScene_1 = require("./MenuScenes/CTGOptionsScene");
const phaser3_ninepatch_1 = require("@koreez/phaser3-ninepatch");
const CTGPracticeScene_1 = require("./MenuScenes/CTGPracticeScene");
const CTGGameInfoScene_1 = require("./MenuScenes/CTGGameInfoScene");
const KHAudioScene_1 = require("./KH/KHAudioScene");
exports.card_size = [11, 13];
exports.game_bounds = [[4, 6], [56, 59]];
const config = {
    type: Phaser.AUTO,
    scale: {
        width: 64,
        height: 64,
        //     mode: Phaser.Scale.FIT,
        autoCenter: Phaser.Scale.CENTER_HORIZONTALLY
    },
    input: {
        gamepad: true,
    },
    plugins: {
        global: [{ key: 'NinePatchPlugin', plugin: phaser3_ninepatch_1.NinePatchPlugin, start: true }],
    },
    parent: "ctg-game",
    pixelArt: true,
    zoom: CTGOptions_1.global_options.scale,
    scene: [CTGPreloadScene_1.CTGPreloadScene, CTGMainMenuScene_1.CTGMainMenuScene, CTGGameScene_1.CTGGameScene, CTGCreditsScene_1.CTGCreditsScene, CTGOptionsScene_1.CTGOptionsScene, CTGPracticeScene_1.CTGPracticeScene, CTGGameInfoScene_1.CTGGameInfoScene, KHInputScene_1.KHInputScene, KHAudioScene_1.KHAudioScene]
};
exports.game = new Phaser.Game(config);
exports.game.sound.mute = CTGOptions_1.global_options.mute;
document.addEventListener("keydown", e => {
    if (e.key == "+" || e.key == "=") {
        set_scale(CTGOptions_1.global_options.scale + 1);
    }
    if (e.key == "-") {
        set_scale(CTGOptions_1.global_options.scale - 1);
    }
});
function set_scale(scale) {
    CTGOptions_1.global_options.scale = Math.min(10, Math.max(1, scale));
    console.log("set scale " + scale);
    exports.game.canvas.style.width = (64 * CTGOptions_1.global_options.scale).toString() + 'px';
    exports.game.canvas.style.height = (64 * CTGOptions_1.global_options.scale).toString() + 'px';
}
exports.set_scale = set_scale;
class KHGameManager {
    constructor(game) {
    }
    add_or_get_audio_scene(scene) {
        if (this.audio == null) {
            scene.scene.run("KHAudioScene");
            this.audio = scene.scene.get("KHAudioScene");
        }
        return this.audio;
    }
}
exports.KHGameManager = KHGameManager;
exports.game_manager = new KHGameManager(exports.game);
